import React, { useEffect } from "react";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import robotoFont from "../../fonts/Roboto-Regular-base64";

const ExportButtons = ({ data }) => {
  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS("Roboto-Regular.ttf", robotoFont);
        this.addFont("Roboto-Regular.ttf", "Roboto", "normal");
      },
    ]);
  }, []);

  const exportPDF = () => {
    const doc = new jsPDF();

    doc.setFont("Roboto");
    doc.text("Lista Membri", 14, 15);

    autoTable(doc, {
      head: [[
        "Prenume",
        "Nume",
        "CNP",
        "Serie si Nr. Buletin",
        "Telefon",
        "Email",
        "Adresa",
        "Judet",
        "Tara",
      ]],
      body: data.map((m) => [
        m.prenume || "",
        m.nume || "",
        m.cnp || "",
        m.serie_numar_ci || "",
        m.telefon || "",
        m.email || "",
        m.adresa || "",
        m.judet || "",
        m.tara || "",
      ]),
      startY: 20,
      styles: { font: "Roboto", fontSize: 8 },
      headStyles: { fillColor: [1, 53, 141], textColor: 255 },
    });

    doc.save("membri.pdf");
  };

  const exportExcel = () => {
    // Mapăm datele pentru a avea aceleași coloane și ordinea lor în Excel
    const exportData = data.map((m) => ({
      Prenume: m.prenume || "",
      Nume: m.nume || "",
      CNP: m.cnp || "",
      "Serie și Nr. Buletin": m.serie_numar_ci || "",
      Telefon: m.telefon || "",
      Email: m.email || "",
      Adresa: m.adresa || "",
      Judet: m.judet || "",
      Tara: m.tara || "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Membri");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(dataBlob, "membri.xlsx");
  };

  return (
    <div className="d-flex gap-3 mt-3 neumorphic p-3 rounded justify-content-center">
      <button className="btn btn-outline-primary" onClick={exportPDF}>
        Exportă PDF
      </button>
      <button className="btn btn-outline-success" onClick={exportExcel}>
        Exportă Excel
      </button>
    </div>
  );
};

export default ExportButtons;
